import styled from '@emotion/styled';
import Responsive from '../../utils/Responsive';

export const StyledContactCardPhoneNumber = styled.div<{}>`
	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		display: none;
	}
`;
